import { render, staticRenderFns } from "./CustomMultiSelectCategory.vue?vue&type=template&id=4a0523e0&"
import script from "./CustomMultiSelectCategory.vue?vue&type=script&lang=js&"
export * from "./CustomMultiSelectCategory.vue?vue&type=script&lang=js&"
import style0 from "./CustomMultiSelectCategory.vue?vue&type=style&index=0&id=4a0523e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports